import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PagesnavbarComponent } from './pagesnavbar.component';
import { RouterModule } from '@angular/router';
@NgModule({
  imports: [
      RouterModule,
      CommonModule
  ],
  declarations: [PagesnavbarComponent],
  exports: [ PagesnavbarComponent ]
})
export class PagesnavbarModule { }



// WEBPACK FOOTER //
// /Users/maikelbald/laboratorio/NossaCidadeMelhor/angular-app/src/app/shared/pagesnavbar/pagesnavbar.module.ts